// extracted by mini-css-extract-plugin
export var label = "_cw-2";
export var slideContainer = "_cw-0";
export var slider = "_cw-1";